export default __webpack_public_path__ + "static/media/producto.e0f84667.svg";